export const addToCart = async (
  productId,
  quantity = 1,
  variationId = 0,
  data = {}
) => {
  return await jQuery.post(hs.ajaxUrl, {
    action: "hs_add_to_cart",
    product_id: productId,
    quantity: quantity || 1,
    variation_id: variationId || 0,
    custom_data: data,
  });
};

/**
 * Add multiple products to cart
 * @param {Array} productIds - Array of product IDs to add
 * @param {number} variationId - Variation ID for the first product (if applicable)
 * @param {object} data - Custom field data for the first product (if applicable)
 * @returns {Promise} - AJAX response
 */
export const addBundleToCart = async (
  productIds,
  variationId = 0,
  data = {}
) => {
  return await jQuery.post(hs.ajaxUrl, {
    action: "hs_add_multiple_to_cart",
    product_ids: productIds,
    variation_id: variationId || 0,
    custom_data: data,
  });
};

export const updateCartItemQuantity = async (
  cartItemKey,
  quantity,
  retryCount = 0
) => {
  try {
    const response = await jQuery.post(hs.ajaxUrl, {
      action: "hs_update_cart_item_quantity",
      cart_item_key: cartItemKey,
      quantity: quantity,
    });

    if (!response || typeof response !== "object") {
      throw new Error("Invalid response from server");
    }

    if (!response.success) {
      throw new Error(response.data?.message || "Failed to update cart");
    }

    return response;
  } catch (error) {
    console.error("Error updating cart:", error);

    // Retry logic - maximum 2 retries
    if (retryCount < 2) {
      await new Promise((resolve) => setTimeout(resolve, 1000)); // Wait 1 second before retry
      return updateCartItemQuantity(cartItemKey, quantity, retryCount + 1);
    }

    throw error;
  }
};

export const getCartItemsCount = () => {
  const cart = wp.data.select("wc/store/cart");
  const cartData = cart.getCartData();
  return cartData.itemsCount;
};

export const getCartCount = async () => {
  try {
    const response = await jQuery.get(hs.ajaxUrl, {
      action: "hs_get_cart_count",
    });
    if (response.success) {
      return response.data.count;
    } else {
      return 0;
    }
  } catch (error) {
    console.error(error);
  }
};
